var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-content" }, [
      _c("div", { staticClass: "main-content-inner" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "page-content",
            staticStyle: { "padding-top": "100px" }
          },
          [
            _vm.loading
              ? _c("div", { attrs: { id: "loading" } }, [
                  _c("div", { staticClass: "loadingMsg" })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "alert alert-danger",
                attrs: { id: "error-alert" }
              },
              [_vm._v("\n          " + _vm._s(_vm.message) + "\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "alert alert-success",
                attrs: { id: "success-alert" }
              },
              [_vm._v("\n          " + _vm._s(_vm.message) + "\n        ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c(
                  "form",
                  { staticClass: "form-horizontal", attrs: { role: "form" } },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        { staticClass: "col-sm-2 no-padding-right" },
                        [_vm._v("利用開始日時")]
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "no-padding-right float-left" },
                        [_vm._v("いまから")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-1" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.passagesData.terms,
                                expression: "passagesData.terms"
                              }
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.passagesData,
                                  "terms",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "0" } }, [
                              _vm._v("時間を選択")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.listTimes, function(item) {
                              return _c(
                                "option",
                                {
                                  key: item.value,
                                  domProps: { value: item.value }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(item.text) +
                                      "\n                  "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "no-padding-right float-left" },
                        [_vm._v("後まで通門可能")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        { staticClass: "col-sm-2 no-padding-right" },
                        [_vm._v("許可ゲート")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-3" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.passagesData.gateId,
                                expression: "passagesData.gateId"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              "data-placeholder": "ゲート選択",
                              id: "gate",
                              disabled: _vm.passagesData.terms === "0"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.passagesData,
                                  "gateId",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "0" } }, [
                              _vm._v("ゲートを選択")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.listGatePassages, function(item) {
                              return item.gateId.gateId !== "nodata" &&
                                item.gateId.makerCode !== 91
                                ? _c(
                                    "option",
                                    {
                                      key: item.gateId.gateId,
                                      domProps: { value: item.gateId.gateId }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.gateId.gateName) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.listGroupPassages, function(item) {
                              return item.gateId.gateId !== "nodata" &&
                                item.gateId.makerCode !== 91
                                ? _c(
                                    "option",
                                    {
                                      key: item.gateId.gateId,
                                      domProps: { value: item.gateId.gateId }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.gateId.gateName) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            })
                          ],
                          2
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "col-md-offset-2 col-sm-4" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.passagesData.isOnce,
                                  expression: "passagesData.isOnce"
                                }
                              ],
                              staticClass: "ace",
                              attrs: {
                                name: "form-field-checkbox",
                                type: "checkbox"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.passagesData.isOnce)
                                  ? _vm._i(_vm.passagesData.isOnce, null) > -1
                                  : _vm.passagesData.isOnce
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.passagesData.isOnce,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.passagesData.isOnce = $$a.concat([
                                          $$v
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.passagesData.isOnce = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.$set(_vm.passagesData, "isOnce", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "lbl" }, [
                              _vm._v("1回限り有効")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-offset-2 col-sm-4" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info",
                    attrs: {
                      type: "button",
                      disabled:
                        _vm.passagesData.gateId === "0" ||
                        _vm.passagesData.terms === "0"
                    },
                    on: {
                      click: function($event) {
                        _vm.geneKey()
                      }
                    }
                  },
                  [_vm._v("\n              鍵共有キー発行\n            ")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-offset-2 col-sm-8" }, [
                _c("div", { staticStyle: { padding: "10px 0px" } }, [
                  _vm._v(
                    "下記の発行されたURLをコピーして利用者に共有してください。"
                  )
                ]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.passagesData.result,
                      expression: "passagesData.result"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "geneLink", rows: "5", readonly: "" },
                  domProps: { value: _vm.passagesData.result },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.passagesData, "result", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-offset-2 col-sm-4" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info",
                    staticStyle: { "margin-top": "15px" },
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.coppyClipboard()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n              クリップボードへコピー\n            "
                    )
                  ]
                )
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "breadcrumbs ace-save-state",
        attrs: { id: "breadcrumbs" }
      },
      [
        _c("ul", { staticClass: "breadcrumb" }, [
          _c("li", [
            _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
            _vm._v(" "),
            _c("a", { attrs: { href: "#/" } }, [_vm._v("メインメニュー")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "active" }, [_vm._v("鍵共有キー発行")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [
        _c("h3", [_vm._v("鍵共有キー発行")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4140342c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4140342c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/key/KeyAdd.vue
// module id = null
// module chunks = 